export const serverUrl = {
    baseURL: 'https://api.xmygjykj.com/userApi', // 正式环境
    // baseURL: 'https://api.yiguo.nibaba.fun:88/adminApi', // 测试环境
    // baseURL: 'http://127.0.0.1:8080/userApi', // 本地环境
    uploadUrl: '',
    imgUrl: 'https://static.xmygjykj.com/user/',
    url:'http://study.xmygjykj.com'
}
